/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Solo_CtaInputs */

const en_cp_p_solo_cta = /** @type {(inputs: Cp_P_Solo_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request a voucher`)
};

const id_cp_p_solo_cta = /** @type {(inputs: Cp_P_Solo_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minta voucher`)
};

/**
* | output |
* | --- |
* | "Request a voucher" |
*
* @param {Cp_P_Solo_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_solo_cta = /** @type {((inputs?: Cp_P_Solo_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Solo_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_solo_cta(inputs)
	return en_cp_p_solo_cta(inputs)
});